import { render, staticRenderFns } from "./PositionInfoFix.vue?vue&type=template&id=25994cbe&"
import script from "./PositionInfoFix.vue?vue&type=script&lang=js&"
export * from "./PositionInfoFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports